import { IntegrityMonitorDefaultRuleConfigurationWebComponent } from './component/IntegrityMonitorDefaultRuleConfigurationWebComponent';
import { WEB_COMPONENT_INTEGRITY_MONITOR_DEFAULT_RULE_CONFIGURATION } from '../../../webcomponents.constants';

export { IntegrityMonitorDefaultRuleConfigurationWebComponent };

window.customElements.define(
  WEB_COMPONENT_INTEGRITY_MONITOR_DEFAULT_RULE_CONFIGURATION,
  IntegrityMonitorDefaultRuleConfigurationWebComponent
);
